import { customElement } from 'aurelia-framework';
import { bindable } from 'aurelia-typed-observable-plugin';
import { InstalledVersionsData } from '../../model/mobile-app-dashboard';

@customElement('installations-box')
export class InstallationsBoxCustomElement {
  @bindable
  data: InstalledVersionsData;
}
